<template>
  <div class="copy_box" v-if="loading">
    <template v-if="!done">
      <div class="box conflict">
        <div class="thebox">
          <span @click="close" class="fa fa-times-circle closebox"></span>
          <h3><strong>File name conflict</strong> <span><strong>File Compression:</strong></span></h3>
          <div class="theboxtop">
            <div class="body">
              <div class="file_conflict" v-if="!load">
                <p>Compressed file will be renamed to <br /><strong>{{ new_name }}</strong></p>
                <p class="foot"><span class="btn-cancel" @click="do_copy">Continue</span> &nbsp;&nbsp;<span
                    class="btn-continue" @click="do_replace">Overwrite</span></p>
              </div>
              <span class="load" v-if="load">
                <span>
                  <svg width="80px" height="80px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"
                    preserveAspectRatio="xMidYMid" class="lds-dual-ring"
                    style="background: rgba(0, 0, 0, 0) none repeat scroll 0% 0%;">
                    <circle cx="50" cy="50" fill="none" stroke-linecap="round" r="20" stroke-width="4" stroke="#039aed"
                      stroke-dasharray="31.41592653589793 31.41592653589793">
                      <animateTransform attributeName="transform" type="rotate" calcMode="linear"
                        values="0 50 50;360 50 50" keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite">
                      </animateTransform>
                    </circle>
                  </svg>
                </span><br>
                <span>Please wait....</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import cookies from '@/services/cookies'
export default {
  data() {
    return {
      wait: true,
      loading: false,
      done: false,
      load: false,
      new_name: '',
      ids: null
    }
  },
  methods: {
    ...mapMutations([
      'SET_FILE_ACTION',
      'REMOVE_FILE_ACTION',
      'SET_DIRECTORY_CHILDREN',
      'TOGGLE_FILE_INFO',
      'SORT_DIRECTORY_CHILDREN',
      'SORT_STORED_DIRECTORY_CHILDREN',
      'SET_STORED_DIRECTORY_CHILDREN',
      'SET_FILE_INFO_DATA',
      'SET_CURRENT_FILE_ID',
      'SET_CURRENT_DIRECTORY',
      'SET_PATH',
      'HIDE_FILE_INFO',
      'SET_FILE_INDEX',
      'SET_FILES_INDEX',
      'UPDATE_DIRECTORY_CHILDREN'
    ]),
    str_text(str) {
      if (str.length > 24) {
        let fSeg = str.substring(0, 5)
        let sSeg = str.substr(str.length - 12, 7)

        return fSeg + '....' + sSeg
      }

      return str
    },
    loaderclose() {
      this.$parent.closeloader()
    },
    loaderbrowse() {
      this.$parent.browseloader()
    },
    logincall() {
      this.$parent.logincall()
    },
    loader(new_name, old_name, ids) {
      this.loading = true
      this.wait = true
      this.load = false
      this.new_name = new_name
      this.old_name = old_name
      this.done = false
      this.ids = ids
    },
    do_replace() {
      if (this.ids) {
        let that = this

        let data = {
          ids: this.ids,
          token: cookies.getCookie('token'),
          replace: true,
          name: this.old_name
        }

        this.load = true
        this.folders = []

        this.$socket.emit('compress', data, function (data) {
          if (data.data === false) {
            that.loading = false
            that.load = false
            that.seen = false
            that.logincall()
            that.$router.push('/login')
          }

          if (data.data === true && data.message === 'completed') {
            that.load = false
            that.loading = false

            that.$store.getters.DIRECTORY_CHILDREN.map(file => {
              file.is_checked = false
            })

            that.EMPTY_FILE_ACTION()
            that.EMPTY_FILES_INDEX()
            that.SET_FILE_ACTION('')
            that.SET_SELECT_ALL(false)
          }
        })
      }
    },
    do_copy() {
      if (this.ids) {
        let that = this

        let data = {
          ids: this.ids,
          token: cookies.getCookie('token'),
          rename: true,
          name: this.new_name
        }

        this.load = true
        this.folders = []

        this.$socket.emit('compress-files', data, function (data) {
          if (data.data === false) {
            that.loading = false
            that.load = false
            that.seen = false
            that.logincall()
            that.$router.push('/login')
          }

          if (data.data === true && data.message === 'completed') {
            that.load = false
            that.loading = false
            that.UPDATE_DIRECTORY_CHILDREN(data.directory_children)
            that.SORT_DIRECTORY_CHILDREN()

            that.$store.getters.DIRECTORY_CHILDREN.map(file => {
              file.is_checked = false
            })

            that.EMPTY_FILE_ACTION()
            that.EMPTY_FILES_INDEX()
            that.SET_FILE_ACTION('')
            that.SET_SELECT_ALL(false)
          }
        })
      }
    },
    close() {
      this.loading = false
      this.wait = false
    }
  }
}
</script>
